module.exports = __webpack_public_path__ + "img/weddings_30_V.cbe3208b.webp";